import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { HenviserDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/henviser-dto';

@Component({
    selector: 'app-henviser-input',
    templateUrl: './henviser-input.component.html',
    styleUrls: ['./henviser-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HenviserInputComponent implements OnInit, OnChanges, OnDestroy {
  filteredHenvisere: Observable<HenviserDto[]>;

  @Input() form: UntypedFormGroup;
  @Input() henvisere: HenviserDto[];

  henviserCtrl = new UntypedFormControl(null);
  unsubscribe$ = new Subject<void>();

  get cvr() {
    return this.form.get('henviserCvr');
  }

  constructor() {}

  ngOnInit(): void {
    this.filteredHenvisere = this.henviserCtrl.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
      map((henviser) => (henviser ? this._filter(henviser) : this.henvisere.slice().map((y) => y)))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.henvisere && this.henvisere) {
      const henviser = this.henvisere.find((x) => x.cvr == this.cvr.value);
      if (henviser) {
        this.henviserCtrl.patchValue(henviser);
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  private _filter(value: string): HenviserDto[] {
    if (typeof value !== 'string') return;
    const filterValue = value.toLowerCase();
    return this.henvisere.filter((option) => option.name.replace(/\s/g, '').toLowerCase().indexOf(filterValue) >= 0);
  }

  displayFn(henviser: any): string {
    return henviser && henviser.name ? henviser.name : '';
  }

  henviserSelected(event: any) {
    const henviser = event.option.value as HenviserDto;
    this.cvr.patchValue(henviser.cvr);
  }

  onBlur() {
    //We defer blur as it is thrown when selecting from autocomplete, causing an empty select when selecting
    setTimeout(() => {
      const henviserVal = this.henviserCtrl.value;
      if (typeof henviserVal === 'string') {
        this.cvr.patchValue(null, { emitEvent: true });
      }
    }, 200);
  }
}
